import React from 'react';
import clsx from 'clsx';
import { StepperTextBlock } from '@marriott/mi-ui-library';
import { MAX_ATTENDEES, MIN_ATTENDEES } from '../../constants';
import { AttendeesStepperProps } from './AttendeesStepper.types';

export const AttendeesStepper = ({
  labels,
  value,
  onIncrement,
  onDecrement,
  onInputChange,
  fieldError,
}: AttendeesStepperProps) => {
  return (
    <div className="stepper-section mt-2">
      <div className={clsx(fieldError && 'stepper-error')}>
        <StepperTextBlock
          copyText={labels.attendees}
          subHeadingText={labels.message}
          stepperValue={value}
          handleIncrement={onIncrement}
          handleDecrement={onDecrement}
          disableIncrement={value === MAX_ATTENDEES}
          disableDecrement={value === MIN_ATTENDEES}
          increamentLabel={`Increase ${labels.label}`}
          decreamentLabel={`Decrease ${labels.label}`}
          variation={'bordered'}
          isInputEditable={true}
          ariaLabel={labels.label}
          onInputChange={onInputChange}
        />
      </div>
      {fieldError ? <p className="stepper-error-text">{fieldError}</p> : null}
    </div>
  );
};
